import React, { Component, Fragment } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { withSnackbar } from 'notistack';
import { Container, Grid, Tooltip, IconButton, TextField, Button, Badge,Dialog, Avatar, CircularProgress } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import QuestionAnswerIcon from '@material-ui/icons/QuestionAnswer';
import ForumIcon from '@material-ui/icons/Forum';
import NotificationsActiveIcon from '@material-ui/icons/NotificationsActive';
import UserDropDownMenu from './UserDropDownMenu';
import FiberNewIcon from '@material-ui/icons/FiberNew';
import HeadsetMicIcon from '@material-ui/icons/HeadsetMic';
import WhatsNewCompleteList from './WhatsNewCompleteList';
import FAQsList from './FAQsList';
import ReportAnIssue from './ReportAnIssue';
import PageLoader from './PageLoader';
import ApplicationSw from './ApplicationSw';
import { getLocalStorageInfo, eraseGlobalCookie,clearCookie, checkApiStatus, getGlobalCookie } from '../../utils';
import { getWhatsNewFeaturesListApi, getFaqsListApi } from '../apiServices';
import { lessorUpdateApi } from '../../application/auth/apiServices'
import { globalGetService } from '../../utils/globalApiServices';
import * as actions from '../actions';
import Cookies from 'universal-cookie';
import config from '../../config';
const cookies = new Cookies();
class DesktopHeader extends Component {
  constructor(props){
    super(props);
    this.state = {
      pageLoader:false,
      lessorList:[],
      formSubmitLoader:false,
      whtsNewModal:false,
      whtsNewList:[],
      faqsModal:false,
      faqsList:[],
      headerCount:{},
      appswictherModal:false
    }
    this.getWhatsNewFeaturesListApi = getWhatsNewFeaturesListApi.bind(this);
    this.getFaqsListApi = getFaqsListApi.bind(this);
    this.lessorUpdateApi = lessorUpdateApi.bind(this);
  }
  componentDidMount(){
    globalGetService('/sso-lessor/list/')
    .then(response => {
      if(checkApiStatus(response)){
        let userInfo = getLocalStorageInfo();
        userInfo = {
          ...userInfo,
          lessor_list: response.data.data
        }
        this.setState({lessorList:response.data.data})
        localStorage.setItem('userInfo', JSON.stringify(userInfo));
      }
    })
  }

  logout = () => {
    localStorage.clear();
    clearCookie('lessorAccess', '.sparta.aero', '/')
    eraseGlobalCookie('lessorAccess')
    eraseGlobalCookie('domain')
    eraseGlobalCookie('userName')
    cookies.remove('lessorAccess' , {path: "/", domain: "sparta.aero"})
    cookies.remove('userName' , {path: "/", domain: "sparta.aero"})
    this.props.history.push('/login')
    // trackLogOut()
  }
  render(){
    const { whtsNewModal, whtsNewList, faqsModal, faqsList, pageLoader, formSubmitLoader, headerCount, lessorList } = this.state;
    let baseUrl = config.domain.subDomian;
      console.log("pageLoader", pageLoader);
    return(
      <Fragment>
        <header className="desktop-header">
          <Container maxWidth={false}  style={{padding:'6px 5px'}}>
            <Grid container  spacing={0} alignItems="center" justify="center">
              <Grid item xs={5}>
                <ul className="list-inline app-logo-search flex-centered">
                  <li className="list-inline-item app-logo">
                  <a href={config.domain.subDomian} target="_blank" rel="noopener noreferrer">
											<img src="https://sparta-aims.ams3.cdn.digitaloceanspaces.com/others/assets/img/sparta_logo.png" alt="Sparta" />
										</a>
                  </li>
                  <li>
                  <Button
                      className="app-switcher"
                      aria-controls="simple-menu"
                      aria-haspopup="true"
                      onClick={() =>this.setState({appswictherModal:true})}
                      endIcon={<ArrowDropDownIcon />}
                    >
                      fin-S
                    </Button>
                  </li>
                </ul>
              </Grid>
              <Grid item xs={7}>
                <ul className="list-inline header-right-nav flex-centered">
                  <li className="list-inline-item">
                    <Tooltip title="What/'s New'" arrow>
                      <a href={`${config.domain.subDomian}whats-new?application=14`} target="_blank">
                        <IconButton size="small" color="primary">
                          <FiberNewIcon />
                        </IconButton>
                    </a>
                    </Tooltip>
                  </li>
                  <li className="list-inline-item">
                    <ReportAnIssue type="head" />
                  </li>
                  <li className="list-inline-item">
                    <Tooltip title="FAQs" arrow>
                      <IconButton onClick={() => window.open(`${baseUrl}faqs?application=14`, "_blank")}> <ForumIcon color='primary' fontSize='small' /></IconButton>
                    </Tooltip>
                  </li>
                  <li className="list-inline-item">
                    <Tooltip title="Notifications" arrow>
                      <IconButton size="small" color="primary">
                        <a href={`${baseUrl}notifications`} target="_blank">
                          <Badge max={99} badgeContent={headerCount.notification_count ? headerCount.notification_count : 0} color="secondary">
                            <NotificationsActiveIcon color="primary" fontSize="small" />
                          </Badge>
                        </a>
                      </IconButton>
                    </Tooltip>
                  </li>
                  <li className="list-inline-item" style={{width:'200px'}}>
                    <Autocomplete
                      options = {lessorList}
                      clearOnBlur={false}
                      getOptionLabel={option => option.name}
                      disableClearable={true}
                      filterSelectedOptions={true}
                      value={{id:getLocalStorageInfo() && getLocalStorageInfo().defaultLessor  && getLocalStorageInfo().defaultLessor.id ? getLocalStorageInfo().defaultLessor.id  : null , name: getLocalStorageInfo() && getLocalStorageInfo().defaultLessor && getLocalStorageInfo().defaultLessor.name ? getLocalStorageInfo().defaultLessor.name : '' }}
                      onChange={(e, data) => this.lessorUpdateApi(this.props, {lessor_id:data.id})}
                      renderInput={params => <TextField {...params} margin="none" fullWidth InputLabelProps={{shrink: true}} />}
                    />
                  </li>
                  <li className="list-inline-item">
                    <UserDropDownMenu
                      logout={this.logout}
                    />
                  </li>
                </ul>
              </Grid>
            </Grid>
          </Container>
          { whtsNewModal ?
            <WhatsNewCompleteList toggleModalFn={() => this.setState({whtsNewModal:false})} modal={whtsNewModal} whtsNewList={whtsNewList} />:null
          }
          { faqsModal ?
            <FAQsList medialLink={this.state.medialLink} toggleModalFn={() => this.setState({faqsModal:false})} modal={faqsModal} faqsList={faqsList} />:null
          }
            { this.state.appswictherModal ?
            <Dialog
              open={this.state.appswictherModal}
              onClose={() => this.setState({appswictherModal:false})}
              aria-labelledby="scroll-dialog-title"
              fullScreen={true}
              className='application-swicther-modal'
            >
              <ApplicationSw
                handleClose={() => this.setState({appswictherModal:false})}
              />
            </Dialog>
            : null
        }
        </header>
        <div style={{height:'52px'}}></div>
        <ReportAnIssue type="foot" />
        { pageLoader || formSubmitLoader ? <PageLoader/>:null }
      </Fragment>
    )
  }
}
const mapStateToProps = state => ({
})
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    toggleTheAppSwitcher: (flag) => dispatch({type:actions.APPS_SWITCHER, payload:flag}),
  }
}

export const HeaderShell = () => {
  let user = {}
  try { user = JSON.parse(getGlobalCookie('userName')) || {} } catch (e) { user = {} }
  return(
    <header className="desktop-header">
      <Container maxWidth={false}  style={{padding:'6px 5px'}}>
        <Grid container  spacing={0} alignItems="center" justify="center">
          <Grid item xs={5}>
            <ul className="list-inline app-logo-search flex-centered">
              <li className="list-inline-item app-logo">
                <img src="https://sparta-aims.ams3.cdn.digitaloceanspaces.com/others/assets/img/sparta_logo.png" alt="Sparta" style={{width:'35px', paddingLeft:'10px'}} />
              </li>
              <li>
                <Button className="app-switcher" endIcon={<ArrowDropDownIcon />} disabled>fin-S</Button>
              </li>
            </ul>
          </Grid>
          <Grid item xs={7}>
            <ul className="list-inline header-right-nav flex-centered">
              <li className="list-inline-item"><FiberNewIcon color="primary" fontSize="small" /></li>
              <li className="list-inline-item"><HeadsetMicIcon color="primary" fontSize="small" /></li>
              <li className="list-inline-item"><QuestionAnswerIcon color="primary" fontSize="small" /></li>
              <li className="list-inline-item"><NotificationsActiveIcon color="primary" fontSize="small" /></li>
              <li className="list-inline-item" style={{width:'200px'}}>
                <Autocomplete
                  options={[]}
                  disabled
                  disableClearable={true}
                  value={null}
                  renderInput={params => (
                    <TextField
                      {...params}
                      margin="none"
                      fullWidth
                      placeholder="Loading..."
                      InputLabelProps={{shrink: true}}
                      InputProps={{...params.InputProps, endAdornment: <Fragment>{params.InputProps.endAdornment}</Fragment>}}
                    />
                  )}
                />
              </li>
              <li className="list-inline-item">
                <div className="user-menu-dropdown">
                  <Button style={{padding: '0', cursor: 'default'}} disableRipple>
                    <Avatar alt={user.name ? user.name : ''} style={{marginRight: '10px', width: '34px', height: '34px'}} />
                    <div style={{textAlign: 'left'}}>
                      <h3>{user.name ? user.name : ''}</h3>
                      <span>{user.designation ? user.designation : ''}</span>
                    </div>
                  </Button>
                </div>
              </li>
            </ul>
          </Grid>
        </Grid>
      </Container>
    </header>
  )
}
export default withSnackbar(withRouter(connect(mapStateToProps, mapDispatchToProps)(DesktopHeader)))
